import { Col, Row, Tooltip } from 'antd';
import ReactCountryFlag from 'react-country-flag';

const NutrientCountries = (props) => {
  const data = [];

  if (Object.keys(props.data).length > 0) {
    for (const country in props.data) {
      data.push({
        countryCode: country,
        value: props.data[country],
      });
    }
  }
  data.sort((a, b) => b.value - a.value);

  return (
    <Row justify="space-around">
      {data.map((country) => (
        <Col key={country.countryCode} xs={6} md={5} lg={2}>
          <Tooltip title={Number.parseInt(country.value)}>
            <ReactCountryFlag
              style={{ fontSize: '6em' }}
              countryCode={country.countryCode}
              svg
            />
          </Tooltip>
        </Col>
      ))}
    </Row>
  );
};

export default NutrientCountries;
